var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"responsiveheader"},[_c('div',{staticClass:"topnav"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("sigmafoli"),_c('span',{staticClass:"optifolio-sigma"},[_vm._v("σ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }